import axios from 'axios'
import config from '../config'
import { getCookieValue } from '.'

/**
 * This function sets the default base URL for the axios requests
 * @param {String} baseURL The base URL
 */
const setAxiosBaseURL = baseurl => {
  axios.defaults.baseURL = baseurl
}

/**
 * This function sets the axios authorization header
 * @param {String} auth The authorization string for the request header
 */
const setAuthHeader = auth => {
  axios.defaults.headers.common['Authorization'] = auth
}

/**
 * This function sets the axios content-type header
 * @param {String} contentType The content-type string for the request header
 */
const setAxiosHeaderContentType = contentType => {
  axios.defaults.headers.common['Content-Type'] = contentType
}

/**
 * This function sets the axios accept-language header
 * @param {String} language The language to be set in the request header.
 * If undefined, the language value will be taken from the cookie or set to "en-EN" by default.
 */
export const setAxiosHeaderAcceptLang = language => {
	// define "Accept-Language" values
	const eng = 'en-US,en;q=0.9'
	const ger = 'de-DE,de;q=0.9'
	let lang
	// if function has language parameter, use it
	if (language) {
		lang = language === 'de' ? ger : eng
	} else {
		// else, use cookie parameter
		const cookieLang = getCookieValue('lang')
		lang = cookieLang === 'de' ? ger : eng
	}
	// set headers to variable "lang" or to variable "eng" if "lang" is still undefined
	axios.defaults.headers.common['Accept-Language'] = lang || eng
}

/**
 * This function sets the default headers for the axios requests.
 */
export const setAxiosDefaultHeaders = () => {
  const credentials = localStorage.getItem('_verificationToken')
  if (credentials !== null && typeof credentials !== 'undefined') {
    setAuthHeader('Bearer ' + credentials)
  } else {
    localStorage.clear()
  }
  setAxiosBaseURL(config.BASE_API_URL)
  setAxiosHeaderContentType('application/json')
  setAxiosHeaderAcceptLang()
}
